import { RootStore } from './RootStore';

export default RootStore;
